import { LocalPlansType } from "@/types/PlansType";

export const localOldPlans: LocalPlansType[] = [
  {
    id:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "ec775675-6ca8-4404-a89d-5830ae60fb6c"
        : "590b42f9-02cd-4269-b9d3-d35c4a7c0e5c",
    catalogId:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "8fe4fc23-ce62-4bd2-871e-4c4dd23d7053"
        : "e142e892-4458-4c56-819a-306571949dd1",
    name: "8GB de internet + 2GB de bônus",
    catalogTag: "join",
    title: "10GB",
    franchise: 8,
    bonus: 2,
    appsTitle: "Apps ilimitados",
    apps: ["whatsapp", "waze", "claromusica"],
    unlimitedAppsTitle: "",
    unlimitedApps: [],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "",
    skeelo: false,
    coupon: "VIRAFLEX10",
    price: 29.99,
    details: {
      title: "Claro flex 10 GB",
      priceDescription: "Apenas: R$ 29,99 /mês",
      instructionTitle:
        "Para ativar seu Claro flex é necessário possuir um chip Claro pré.",
      instruction: [],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21",
        "Internet: o seu plano tem 10 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região. O bônus de 2 GB tem validade de 12 meses.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.\n",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul>" +
          "<li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></ul>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Claro música: milhões de músicas e playlists exclusivas para você ouvir onde e quando quiser, sem descontar da sua internet.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Waze",
        type: "Ilimitado",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
      {
        description: "SMS",
        type: "Incluso",
      },
    ],
  },
  {
    id:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "956b61ee-fe95-4bb2-8b9d-3f80bd2f8d99"
        : "1f8faf07-4541-43b5-b95a-a1560f7e34bc",
    catalogId:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "bb6c6abe-0203-475f-8532-6bc264c20030"
        : "e142e892-4458-4c56-819a-306571949dd1",
    name: "8GB de internet + 12GB de bônus",
    catalogTag: "join",
    title: "8GB de internet + 12GB de bônus",
    franchise: 8,
    bonus: 12,
    appsTitle: "Apps ilimitados",
    apps: [
      "whatsapp",
      "facebook",
      "instagram",
      "twitter",
      "waze",
      "claromusica",
    ],
    unlimitedAppsTitle: "",
    unlimitedApps: [],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "",
    skeelo: false,
    coupon: "VIRAFLEX20",
    price: 39.99,
    details: {
      title: "Claro flex 20 GB",
      priceDescription: "Apenas: R$ 39,99 /mês",
      instructionTitle:
        "Para ativar seu Claro flex é necessário possuir um chip Claro pré.",
      instruction: [],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 20 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região. O bônus de 15 GB tem validade de 12 meses.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul>" +
          "<li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X: participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "<li><span>Claro música: milhões de músicas e playlists exclusivas para você ouvir onde e quando quiser, sem descontar da sua internet.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Waze",
        type: "Ilimitado",
      },
      {
        description: "Facebook",
        type: "Ilimitado",
      },
      {
        description: "Instagram",
        type: "Ilimitado",
      },
      {
        description: "Twitter",
        type: "Ilimitado",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
    ],
  },
  {
    id:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "f1961042-ae6e-4cab-953d-c4a0e209878c"
        : "0d8fa42d-6d8e-4da9-a68a-b51e947a4b98",
    catalogId:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "bb6c6abe-0203-475f-8532-6bc264c20030"
        : "e142e892-4458-4c56-819a-306571949dd1",
    name: "10GB de internet + 15GB de bônus",
    catalogTag: "join",
    title: "10GB de internet + 15GB de bônus",
    franchise: 10,
    bonus: 15,
    appsTitle: "Apps ilimitados",
    apps: [
      "whatsapp",
      "facebook",
      "instagram",
      "twitter",
      "waze",
      "claromusica",
    ],
    unlimitedAppsTitle: "",
    unlimitedApps: [],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "",
    skeelo: false,
    coupon: "VIRAFLEX20",
    price: 49.99,
    details: {
      title: "Claro flex 25 GB",
      priceDescription: "Apenas: R$ 49,99 /mês",
      instructionTitle:
        "Para ativar seu Claro flex é necessário possuir um chip Claro pré.",
      instruction: [],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 25 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região. O bônus de 15 GB tem validade de 12 meses.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul>" +
          "<li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X: participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "<li><span>Claro música: milhões de músicas e playlists exclusivas para você ouvir onde e quando quiser, sem descontar da sua internet.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Waze",
        type: "Ilimitado",
      },
      {
        description: "Facebook",
        type: "Ilimitado",
      },
      {
        description: "Instagram",
        type: "Ilimitado",
      },
      {
        description: "Twitter",
        type: "Ilimitado",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
    ],
  },
  {
    id:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "41a68b43-fde4-4795-bca1-a1dd311a34e9"
        : "e6647dbe-b7df-4dd4-8323-7ad638c10ca6",
    catalogId:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "bb6c6abe-0203-475f-8532-6bc264c20030"
        : "273244dc-aaaf-4974-80d0-aefbe0a9be2a",
    name: "16GB de internet + 16GB de bônus",
    catalogTag: "join_teste_ab",
    title: "16GB de internet + 16GB de bônus",
    franchise: 16,
    bonus: 16,
    appsTitle: "Apps ilimitados",
    apps: [
      "tiktok",
      "whatsapp",
      "facebook",
      "instagram",
      "twitter",
      "waze",
      "claromusica",
    ],
    unlimitedAppsTitle: "",
    unlimitedApps: [],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "",
    skeelo: true,
    coupon: "VIRAFLEX20",
    price: 59.99,
    details: {
      title: "Claro flex 32 GB",
      priceDescription: "Apenas: R$ 59,99 /mês",
      instructionTitle:
        "Para ativar seu Claro flex é necessário possuir um chip Claro pré.",
      instruction: [],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 32 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região. O bônus de tem validade de 12 meses.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul>" +
          "<li><span>TikTok: assista os vídeos e trend sem descontar da sua franquia. Não perca nenhum conteúdo do app que é utilizado por milhares de influenciadores do Brasil e do mundo.</span></li>" +
          "<li><span>Skeelo: Um novo eBook por mês, entre os mais vendidos das livrarias, para você ler quando e onde quiser.</span></li>" +
          "<li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X: participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "<li><span>Claro música: milhões de músicas e playlists exclusivas para você ouvir onde e quando quiser, sem descontar da sua internet.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Tik Tok",
        type: "Ilimitado",
      },
      {
        description: "Waze",
        type: "Ilimitado",
      },
      {
        description: "Facebook",
        type: "Ilimitado",
      },
      {
        description: "Instagram",
        type: "Ilimitado",
      },
      {
        description: "Twitter",
        type: "Ilimitado",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
    ],
  },
  {
    id:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "dcba42ab-69ce-4f5a-9ad9-77bb17437238"
        : "03b560ac-ff5d-485f-8a86-8665b859a98b",
    catalogId:
      process.env.VUE_APP_ENV_KEY === "QA"
        ? "bb6c6abe-0203-475f-8532-6bc264c20030"
        : "273244dc-aaaf-4974-80d0-aefbe0a9be2a",
    name: "16GB de internet + 16GB de bônus",
    catalogTag: "join_teste_ab",
    title: "16GB de internet + 16GB de bônus",
    franchise: 16,
    bonus: 16,
    appsTitle: "Apps ilimitados",
    apps: [
      "freefire",
      "whatsapp",
      "facebook",
      "instagram",
      "twitter",
      "waze",
      "claromusica",
    ],
    unlimitedAppsTitle: "",
    unlimitedApps: [],
    servicesTitle: "Serviços ilimitados",
    services: [
      {
        icon: "mdn-Icon-claro mdn-Icon--md",
        alt: "Ligações Claro para Claro",
        color: "#E3262E",
        description: "Ligações Claro para Claro",
      },
      {
        icon: "mdn-Icon-flex-ligacoes mdn-Icon--md",
        alt: "Ligações outras operadoras",
        color: "#E3262E",
        description: "Ligações outras operadoras",
      },
      {
        icon: "mdn-Icon-mensagem-sms mdn-Icon--md",
        alt: "SMS nacional Claro para Claro",
        color: "#E3262E",
        description: "SMS nacional Claro para Claro",
      },
    ],
    includeTitle: "",
    skeelo: true,
    coupon: "VIRAFLEX20",
    price: 59.99,
    details: {
      title: "Claro flex 32 GB",
      priceDescription: "Apenas: R$ 59,99 /mês",
      instructionTitle:
        "Para ativar seu Claro flex é necessário possuir um chip Claro pré.",
      instruction: [],
      benefitsTitle: "Benefícios do plano",
      benefits: [
        "Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21.",
        "Internet: o seu plano tem 32 GB de internet para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região. O bônus de tem validade de 12 meses.",
        "Roaming Nacional: as chamadas recebidas em viagem (fora do seu Estado) não serão cobradas, e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.",
        "<b>Aplicativos para navegar ilimitado que estão inclusos em sua oferta</b><br /><ul>" +
          "<li><span>Free Fire: É um jogo Battle Royale de celular mais popular do Brasil! Jogue sem descontar da sua franquia. Não perca mais nenhuma partida.</span></li>" +
          "<li><span>Skeelo: Um novo eBook por mês, entre os mais vendidos das livrarias, para você ler quando e onde quiser.</span></li>" +
          "<li><span>WhatsApp: use o WhatsApp ilimitado com ligações de voz e vídeo sem descontar da sua franquia e fique sempre conectado com os amigos e familiares.</span></li>" +
          "<li><span>Waze: pegue o melhor caminho todos os dias, com ajuda em tempo real de outros motoristas.</span></li>" +
          "<li><span>Instagram: os melhores momentos da sua vida e de seus amigos eternizados em um aplicativo.</span></li>" +
          "<li><span>Facebook: conecte-se com o mundo inteiro na rede social mais popular do mundo.</span></li>" +
          "<li><span>X: participe das conversas e fique por dentro do que está acontecendo no Brasil e no mundo com textos, foto e vídeos.</span></li>" +
          "<li><span>Claro música: milhões de músicas e playlists exclusivas para você ouvir onde e quando quiser, sem descontar da sua internet.</span></li>" +
          "</ul>",
      ],
    },
    successDetails: [
      {
        description: "Ligações Claro para Claro",
        type: "Ilimitado",
      },
      {
        description: "Ligações outras operadoras",
        type: "Ilimitado",
      },
      {
        description: "Claro Música",
        type: "Ilimitado",
      },
      {
        description: "WhatsApp",
        type: "Ilimitado",
      },
      {
        description: "Free Fire",
        type: "Ilimitado",
      },
      {
        description: "Waze",
        type: "Ilimitado",
      },
      {
        description: "Facebook",
        type: "Ilimitado",
      },
      {
        description: "Instagram",
        type: "Ilimitado",
      },
      {
        description: "Twitter",
        type: "Ilimitado",
      },
      {
        description: "Skeelo",
        type: "Incluso",
      },
    ],
  },
];
